import { BusinessType, FieldError } from "client/lib/apt-merchant";

import { Field } from "../../field";
import { Merchant } from "../../merchant";
import { MerchantField } from "../../types";
import { isNumber } from "../../validate";

const optionalBusinessTypes: BusinessType[] = ["Sole Trader"];

export const regNumErrorMessage = "Field must contain only digits / numbers";

export class RegistrationNumberField extends Field<string> {
  constructor(model: Merchant, opts: Partial<MerchantField<string>> = {}) {
    super(model, {
      dataType: "string",
      testValue: "12345678901234",
      propertyName: "registrationNumber",
      uiFieldType: "Input",
      uiInputBaseProps: {
        inputMode: "numeric",
      },
      ...opts,
    });
  }

  get applicable(): boolean {
    const registeredCountry = this._model.companyInformation.registeredCountry
      .value;
    if (registeredCountry === "New Zealand") {
      return true;
    }
    return false;
  }

  get required(): boolean {
    const businessType = this._model.companyInformation.businessType
      .value as BusinessType;
    const optional = optionalBusinessTypes.includes(businessType);
    return this.applicable && !optional;
  }

  get shown(): boolean {
    return this.applicable;
  }

  _validate(): void {
    if (this.value) {
      if (!isNumber(this.value)) {
        throw new FieldError(this, regNumErrorMessage, "InvalidCompanyNumber");
      }
    }
  }
}
